export default __webpack_public_path__ + "img_220720_BEN_Lockup_H_1_RGB_d.svg";